import { fetchBalance } from "../utils/getCreditApp";


document.addEventListener('DOMContentLoaded', async () => {

  const balance = await fetchBalance();


  if (Number(balance) > 0) {

    document.querySelector('.bar-credit').classList.remove('bar-hidden');
    document.querySelector('.bar-credit').classList.add('bar-sticky');
    const textsAll = document.querySelectorAll('.text-credit p');

    textsAll.forEach(text => {
      text.innerHTML = text.innerHTML.replace(/\[CREDIT\]/g, `$${Number(balance)}`);
    });
  }

});
